import { init } from "@sentry/react-router";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

init({
  dsn: "https://985e71c5a44efa6b31e8d65ea2fb7730@o4509784902729728.ingest.de.sentry.io/4509790580572240",
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
